(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PlannedShipmentDetailController', PlannedShipmentDetailController);

    PlannedShipmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PlannedShipment', 'Contract'];

    function PlannedShipmentDetailController($scope, $rootScope, $stateParams, previousState, entity, PlannedShipment, Contract) {
        var vm = this;

        vm.plannedShipment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccstrtest1App:plannedShipmentUpdate', function(event, result) {
            vm.plannedShipment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
